<template>
  <main class="main">
    <!-- Banner -->
    <section class="banner banner--model little--grey">
      <div class="container">
        <div class="inner">
          <div class="item">
            <div class="nav__links">
              <h1>{{ data.header.title }}</h1>
            </div>
          </div>
          <div class="item">
            <img src="../assets/perso/girls2.png" alt="Happy Women">
          </div>
        </div>
        
      </div>
      <div class="mask"></div>
    </section>
    <section class="banner banner--form">
      <div class="container">
        <div class="banner--copy">
          
          <h2>{{ data.intro.title }}</h2>
          
          <div class="row" v-for="(data, index) in data.body" :key="data.body">  
            <h3>{{index + 1+'.'}} {{ data.title }}</h3>
            
            <template v-if="data.text" v-for="text in data.text">
              <p>{{ text }}</p>
            </template>
            
            <template v-if="data.subtitle" v-for="(subtitle, subindex) in data.subtitle">
              <template v-if="subtitle.subtitleItem">
                <h4>{{index+1 +'.'}}{{subindex+1 +'.'}} {{ subtitle.subtitleItem }}</h4>
                <p v-for="(text, idx) in subtitle.text" :key="text">{{text}}</p>
                
                <!-- list  -->
                <template v-if="subtitle.list">
                  <ul class="list">
                    <li v-for="(item, idx) in subtitle.list" :key="idx+(10*3)">{{ item }}</li>
                  </ul>
                </template>

                <!-- Level 3 -->
                <template v-if="subtitle.subtitleLevel3">
                  <div v-for="(level3, idx) in subtitle.subtitleLevel3" :key="idx+(10*4)">
                    <h4>{{index+1 +'.'}}{{subindex+1 +'.'}}{{idx+1}} {{ level3.subtitleItem }}</h4>
                    <p v-for="(level3Text, idx) in level3.text" :key="idx+(10*5)">{{level3Text}}</p>
                  </div>
                </template>
              </template>
              
              <template v-else>
                <p>{{index+1 +'.'}}{{subindex+1 +'.'}} {{ subtitle }}</p>
              </template>
            </template>
            
          </div>
        </div>
      </div>
      <div class="mask"></div>
    </section>
  </main>
</template>

<script>
import PrivacyPolicy from '../contents/privacyPolicy.json'
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
      data: PrivacyPolicy
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/privacyPolicy.vue